var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-widget',_vm._g(_vm._b({attrs:{"multiple":_vm.multiple,"close-on-select":false}},'select-widget',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }